"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmbedStyle = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var EmbedStyle = function EmbedStyle(_a) {
  var styleProps = __rest(_a, []);
  return react_1.default.createElement("style", Object.assign({}, styleProps, {
    className: (0, classnames_1.default)(styleProps.className),
    style: Object.assign({}, styleProps.style)
  }), "\n        .rsme-embed .rsme-d-none {\n          display: none;\n        }\n    \n        .rsme-embed .twitter-tweet {\n          margin: 0 !important;\n        }\n    \n        .rsme-embed blockquote {\n          margin: 0 !important;\n          padding: 0 !important;\n        }\n\n        .rsme-embed.rsme-facebook-embed .fb-post iframe {\n          width: 100% !important;\n        }\n\n        .rsme-embed.rsme-facebook-embed .fb-post span {\n          width: 100% !important;\n        }\n      ");
};
exports.EmbedStyle = EmbedStyle;